import { NavigateFunction } from "react-router-dom";

export const navigateTo = (
  navigate: NavigateFunction,
  path: string,
  e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>
) => {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  if (path) {
    if (window.location.pathname == path) {
      window.location.reload();
    } else {
      navigate(path);
    }
  }
};
